import { Divider, IconButton, IconChevronLeftRegular, IconCloseRegular, Text3, skinVars } from '@telefonica/mistica';
import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import ModalTestInterpretation from '../../pages/home/fiber/modalTestInterpretation';
import ModalSlowConnection from '../../pages/home/fiber/modalSlowConnection';
import ModalTipsToImproveConnection from '../../pages/home/fiber/modalTipsToImproveConnection';
import ModalTestInformation from '../../pages/home/fiber/modalTestInformation';

export interface IModalTestFiber {
    onClose: () => void;
}

export const ModalTestFiber: React.FC<IModalTestFiber> = ({ onClose }: IModalTestFiber) => {
    const { t } = useTranslation();
    const animationInterval = useRef<number | null>(null);
    const nodeRef = useRef<HTMLDivElement>(null);
    const [step, setStep] = useState<number>(0);
    const stepper: { component: JSX.Element; title?: string }[] = [
        {
            component: (
                <ModalTestInformation
                    preventLink={true}
                    onSelect={(index: 'main' | 'interpretation' | 'connection' | 'advices') => handleStepper(index)}
                />
            ),
        },
        { component: <ModalTestInterpretation />, title: t('interpretTest') },
        {
            component: <ModalSlowConnection preventLink={true} onSelect={() => handleStepper('advices')} />,
            title: t('yourConnectionIsSlow'),
        },
        { component: <ModalTipsToImproveConnection />, title: t('tipsToImproveConnection') },
    ];

    const handleStepper = (index: 'main' | 'interpretation' | 'connection' | 'advices') => {
        const actions: { [key: string]: number } = {
            main: 0,
            interpretation: 1,
            connection: 2,
            advices: 3,
        };
        setStep(actions[index]);
    };

    useEffect(() => {
        document.body.style.overflowY = 'hidden';
        animationInterval.current = window.setTimeout(() => {}, 200);
    }, []);

    return (
        <>
            <div className='c-modal' ref={nodeRef}>
                <div className='c-modal-container'>
                    <div className='c-modal-header'>
                        {step !== 0 && (
                            <div className='c-modal-header-preview'>
                                <IconButton
                                    onPress={() => {
                                        setStep(0);
                                    }}
                                    aria-label='exit modal alert test information'
                                >
                                    <IconChevronLeftRegular color={skinVars.colors.neutralHigh} size={20} />
                                </IconButton>
                                <Text3 regular color={skinVars.colors.textPrimary}>
                                    {stepper[step].title}
                                </Text3>
                            </div>
                        )}
                        <IconButton
                            size={55}
                            onPress={() => {
                                onClose();
                            }}
                            aria-label='exit modal alert test information'
                        >
                            <IconCloseRegular />
                        </IconButton>
                        <span className='c-modal-header-divider'>
                            <Divider></Divider>
                        </span>
                    </div>
                    <div className='c-modal-body'>{stepper[step].component}</div>
                </div>
                <div className='c-modal-overlay' onClick={() => onClose()}></div>
            </div>
        </>
    );
};

export default ModalTestFiber;
